(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EventCollectionsDetailController', EventCollectionsDetailController);

    EventCollectionsDetailController.$inject = ['previousState', 'EventCollections','$stateParams',  '$scope', 'SoopkitchenUtils'];

    function EventCollectionsDetailController(previousState, EventCollections, $stateParams, $scope, SoopkitchenUtils) {
        var vm = this;
        var container;

        /**** Properties ****/

        vm.previousState = previousState.name;
        vm.events = [];
        vm.reverse = false;
        vm.predicate = 'name';
        vm.showLog = false;
        vm.waiting = true;

        /**** Methods ****/

        vm.sortTable = sortTable;
        vm.showError = showError;
        vm.createparameters = EventCollections.createparameters;

        EventCollections.getEventCollection($stateParams.id, init, showError);

        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.isUploading = false;
                vm.waiting = false;
                $scope.$apply();
            });
        }

        function init(response) {
            vm.eventCollections= response.data;
            vm.logs = vm.eventCollections.logs;

            for (var eventFile in vm.eventCollections.eventsByFile) {
                if (vm.eventCollections.eventsByFile.hasOwnProperty(eventFile)) {
                    var happenings = vm.eventCollections.eventsByFile[eventFile].happenings;
                    var arrayLength = happenings.length;
                    for (var i = 0; i < arrayLength; i++) {
                        vm.events.push({
                            name: happenings[i].originalName,
                            startDate: happenings[i].startDate,
                            endDate: happenings[i].endDate,
                            parameters: happenings[i].parameters,
                            count: happenings[i].count,
                            source: eventFile,
                            happening: happenings[i]
                        })
                    }
                }
            }
            container = document.getElementById('timeline-view');
            EventCollections.createTimeline(container, vm.eventCollections, vm.events);
            vm.waiting = false;

        }

        function sortTable() {
            vm.events = SoopkitchenUtils.sort(vm.events, vm.predicate, vm.reverse);
            $scope.$apply();
        }
    }
})();
